import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`modern-header ${scrolled ? "scrolled" : ""}`}>
      <Navbar expand="lg" className="modern-navbar">
        <div className="container">
          <Navbar.Brand as={Link} to="/" className="brand-logo">
            <span className="logo-text">ERA SALON</span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto main-nav">
              <NavDropdown
                title="Hair Care Services"
                id="hair-care-dropdown"
                className="nav-dropdown-modern"
              >
                <NavDropdown.Item as={Link} to="/hair-styling">
                  Hair Styling
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/hair-coloring">
                  Hair Coloring
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/hair-texturing">
                  Hair Texturing
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/waxing">
                  Waxing
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={Link} to="/facial-care" className="nav-link-modern">
                Facial Care
              </Nav.Link>

              <NavDropdown
                title="Nail Care Services"
                id="nail-care-dropdown"
                className="nav-dropdown-modern"
              >
                <NavDropdown.Item as={Link} to="/nail-care">
                  Nail Care
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/other-care">
                  Pedicure and Foot Care
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                title="About Us"
                id="about-dropdown"
                className="nav-dropdown-modern"
              >
                <NavDropdown.Item as={Link} to="/about">
                  About Us
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/team">
                  Our Team
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/gallery">
                  Gallery
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/contact">
                  Contact Us
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <Nav className="social-nav">
              <div className="headerSocial">
                <a href="tel:9167221888" className="phone-link" aria-label="Call us">
                  <i className="fas fa-phone"></i>
                  <span className="phone-text">(916) 722-1888</span>
                </a>
                <a
                  href="https://www.facebook.com/Era-salon-305929286474054"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook"></i>
                </a>
                <a
                  href="https://www.google.com/search?sxsrf=ALeKk00mS7SVFP8jWvuxNcrEYyMjfa7DmQ%3A1597278395648&ei=u4g0X9KFJ4H49AP4jongCA&q=era+salon+sac&oq=era+salon+sac&gs_lcp=CgZwc3ktYWIQAzIICAAQsAMQzQIyCAgAELADEM0CMggIABCwAxDNAlAAWABg9MwBaABwAHgAgAFniAFnkgEDMC4xmAEAqgEHZ3dzLXdpesABAQ&sclient=psy-ab&ved=0ahUKEwiSz4Tb9ZbrAhUBPH0KHXhHAowQ4dUDCAw&uact=5"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Google"
                >
                  <i className="fab fa-google"></i>
                </a>
                <a
                  href="https://www.yelp.com/biz/era-salon-citrus-heights-4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Yelp"
                >
                  <i className="fab fa-yelp"></i>
                </a>
              </div>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </header>
  );
}
